"use client";

import React, { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/navigation";
import PricingData from "../../data/pricing.json";

const PricingBanner = ({ parentClass }) => {
  const router = useRouter();

  // Tabs (Mensual / Anual)
  const initialTabId = useMemo(() => {
    const selected = PricingData?.pricing?.find((p) => p.isSelect)?.priceId;
    return selected || PricingData?.pricing?.[0]?.priceId || "";
  }, []);

  const [activeTabId, setActiveTabId] = useState(initialTabId);

  useEffect(() => {
    if (!activeTabId && initialTabId) setActiveTabId(initialTabId);
  }, [activeTabId, initialTabId]);

  const activeSection = useMemo(() => {
    return PricingData?.pricing?.find((p) => p.priceId === activeTabId) || null;
  }, [activeTabId]);

  const visiblePlans = activeSection?.priceBody || [];

  return (
    <div>
      <nav className="aiwave-tab mb--20">
        <div
          className="tab-btn-grp nav nav-tabs text-center justify-content-center"
          role="tablist"
        >
          {PricingData?.pricing?.map((section, idx) => {
            const isActive = section.priceId === activeTabId;

            return (
              <button
                key={idx}
                type="button"
                className={`nav-link ${isActive ? "active" : ""}`}
                onClick={() => setActiveTabId(section.priceId)}
              >
                {section.priceType}
                {section.discount ? (
                  <span className="rainbow-badge-card badge-border">
                    -{section.discount}%
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>
      </nav>

      <div className="tab-content p-0 bg-transparent border-0 border bg-light">
        {activeSection ? (
          <div className="tab-pane fade active show">
            <div
              className={`row row--15 ${
                visiblePlans.length < 3 ? "justify-content-center" : ""
              }`}
            >
              {visiblePlans.map((plan, i) => (
                <div className={parentClass} key={i}>
                  <div
                    className={`rainbow-pricing style-aiwave ${
                      plan.isSelect ? "active" : ""
                    }`}
                  >
                    <div className="pricing-table-inner">
                      <div className="pricing-top">
                        <div className="pricing-header">
                          <div className="icon">
                            <i className={plan.iconClass}></i>
                          </div>
                          <h4 className={`title color-var-${plan.classNum}`}>
                            {plan.subTitle}
                          </h4>
                          <p className="subtitle">{plan.title}</p>
                          <div className="pricing">
                            <span className="price-text">{plan.price}</span>
                            <span className="text">{plan.priceFor}</span>
                          </div>
                        </div>

                        <div className="pricing-body">
                          <div className="features-section has-show-more">
                            <h6>{plan.text}</h6>
                            <ul className="list-style--1 has-show-more-inner-content mb-5">
                              {(plan.listItem || [])
                                .slice(0, 2)
                                .map((item, idx) => (
                                  <li key={idx}>
                                    <i className="fa-regular fa-circle-check"></i>
                                    {item.text}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="pricing-footer">
                        <button
                          type="button"
                          className={`btn-default w-100 ${
                            plan.isSelect ? "color-blacked" : "btn-border"
                          }`}
                          onClick={() => router.push("/planes")}
                        >
                          Ver detalles
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PricingBanner;
